<template>
  <div class="dashboard-chart">
    <b-row v-if="widgetsLoaded">
      <b-col md="3" sm="6" class="mb-4">
        <dashboard-widget
          :title="widgets.impressions.title"
          :amount="widgets.impressions.amount"
          :sub-amount="widgets.impressions.subAmount"
          :sub-title="widgets.impressions.subTitle"
          :change="widgets.impressions.change"
        />
      </b-col>
      <b-col md="3" sm="6" class="mb-4">
        <dashboard-widget
          :title="widgets.budgetDay.title"
          :amount="widgets.budgetDay.amount"
          :sub-amount="widgets.budgetDay.subAmount"
          :sub-title="widgets.budgetDay.subTitle"
          :change="widgets.budgetDay.change"
          :is-currency="true"
        />
      </b-col>
      <b-col md="3" sm="6" class="mb-4">
        <dashboard-widget
          :title="widgets.budgetMonth.title"
          :amount="widgets.budgetMonth.amount"
          :sub-amount="widgets.budgetMonth.subAmount"
          :sub-title="widgets.budgetMonth.subTitle"
          :change="widgets.budgetMonth.change"
          :is-currency="true"
        />
      </b-col>
      <b-col md="3" sm="6" class="mb-4">
        <dashboard-widget
          :title="widgets.balance.title"
          :amount="widgets.balance.amount"
          :is-currency="true"
        >
          <a slot="link" href="#" class="widget-link text-primary">
            Add funds
            <svg-icon icon="chevron-right" />
          </a>
        </dashboard-widget>
      </b-col>
    </b-row>
    <b-row class="mb-4">
      <b-col md="12">
        <div class="dashboard-chart__controls">
          <div class="d-flex">
            <div
              class="border-merged"
              :class="{
                'border-merged--on-top': focusedSwitcher === 'dimensions'
              }"
            >
              <multi-select
                :select-options="dimensionList"
                size="lg"
                btn-class="rounded-0"
                :options="{ multi: true }"
                btn-label="Dimensions"
                v-model="activeDimensions"
                @opened="focusFilter('dimensions')"
                @closed="unfocusFilter()"
              />
            </div>
          </div>
          <div class="dashboard-chart__filters"><filter-dashboard /></div>
        </div>
      </b-col>
      <b-col md="12">
        <box class="pt-4 pl-2 pr-2 pb-2 rounded-0 border-top">
          <line-chart :data="chartData" />
        </box>
      </b-col>
    </b-row>
    <table-stats :data="stats.table.data" :fields="stats.table.fields" />
  </div>
</template>

<script>
import LineChart from '@/components/Charts/LineChart.vue';
import DashboardWidget from '@/views/Dashboard/components/DashboardWidget.vue';
import FilterDashboard from '@/views/Dashboard/components/FilterDashboard.vue';
import TableStats from '@/components/TableStats/index.vue';

export default {
  components: {
    LineChart,
    FilterDashboard,
    DashboardWidget,
    TableStats
  },

  data() {
    return {
      isLoaded: false,
      widgetsLoaded: false,
      widgets: {},
      focusedSwitcher: '',
      activeDimensions: [],
      stats: {
        table: {
          sortBy: 'date',
          sortDesc: false,
          fields: [],
          data: []
        }
      }
    };
  },

  computed: {
    dimensionList() {
      return this.stats.table.fields
        .map(el => {
          if (el.key === 'date' || el.key === 'key') return;
          return { id: el.key, name: el.label };
        })
        .filter(el => el !== undefined);
    },
    chartData() {
      const data = [];
      this.activeDimensions.forEach(dimension => {
        data.push({
          name: dimension.name,
          data: this.stats.table.data.map(el => [el.date, el[dimension.id]])
        });
      });
      return data;
    }
  },

  methods: {
    loadWidgetStats() {
      this.$store.dispatch('advert/fetchAdvDashboardWidgets').then(
        res => {
          this.widgets = res.data;
          this.widgetsLoaded = true;
        },
        e => {
          this.widgetsLoaded = false;
          this.$store.commit('SET_PAGE_FAILURE', e);
        }
      );
    },
    focusFilter(val) {
      this.focusedSwitcher = val;

      // hack()
      setTimeout(() => {
        this.focusedSwitcher = val;
      }, 100);
    },
    unfocusFilter() {
      this.focusedSwitcher = '';
    }
  },

  watch: {
    activeDimensions() {
      if (this.activeDimensions.length === 0 && this.dimensionList[0]) {
        this.activeDimensions.push(this.dimensionList[0]);
        this.activeDimensions.push(this.dimensionList[1]);
      }
    }
  },

  created() {
    this.loadWidgetStats();
    this.$api.adnet.get('/v0/adv-dashboard-stats').then(res => {
      res.fields = res.fields.map(el => {
        return {
          ...el,
          sortable: !this.compare
        };
      });
      this.stats.table = {
        ...this.stats.table,
        ...res
      };
    });
  }
};
</script>
